'use client'

import { useEffect, useState } from 'react'
import { MdSwapHoriz } from 'react-icons/md'
import { UserSelector } from '@/components/UserSelector'

interface TransferSellerModalProps {
    isOpen: boolean
    onClose: () => void
    onConfirm: (sellerId: number) => Promise<void>
    loading?: boolean
    /** Vendedor atual, para exibir de quem a venda está sendo transferida. */
    currentSellerName?: string | null
    /** Empresa do atendimento — escopo da busca de usuários. */
    companyId?: number
}

/**
 * Transferência de vendedor (createdBy) de um atendimento — exame, consulta, procedimento.
 *
 * Compartilhado pelos três, já que a ação é idêntica. A autorização (quem pode transferir)
 * é validada no backend; aqui só coletamos o novo vendedor.
 */
export default function TransferSellerModal({
    isOpen,
    onClose,
    onConfirm,
    loading = false,
    currentSellerName,
    companyId,
}: TransferSellerModalProps) {
    const [sellerId, setSellerId] = useState<number | null>(null)

    useEffect(() => {
        if (isOpen) setSellerId(null)
    }, [isOpen])

    if (!isOpen) return null

    return (
        <dialog className="modal modal-open">
            <div className="modal-box max-w-lg overflow-visible">
                <h3 className="font-bold text-lg flex items-center gap-2">
                    <MdSwapHoriz className="text-secondary text-xl" />
                    Transferir vendedor
                </h3>

                <p className="text-sm text-base-content/70 mt-2">
                    A venda deixará de constar em nome de{' '}
                    <strong>{currentSellerName || 'quem a criou'}</strong> e passará ao
                    usuário selecionado abaixo.
                </p>

                <div className="mt-5">
                    <UserSelector
                        label="Novo vendedor"
                        placeholder="Buscar usuário..."
                        value={sellerId}
                        onChange={id => setSellerId(id)}
                        disabled={loading}
                        companyId={companyId}
                    />
                </div>

                <div className="modal-action">
                    <button
                        type="button"
                        className="btn btn-ghost"
                        onClick={onClose}
                        disabled={loading}
                    >
                        Voltar
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        disabled={loading || sellerId == null}
                        onClick={() => sellerId != null && onConfirm(sellerId)}
                    >
                        {loading ? 'Transferindo...' : 'Confirmar transferência'}
                    </button>
                </div>
            </div>
            <form method="dialog" className="modal-backdrop">
                <button type="button" onClick={onClose} disabled={loading}>
                    fechar
                </button>
            </form>
        </dialog>
    )
}
